import { useState } from "react";
import { useTranslation } from "react-i18next";

import "./Process.css";

const Process = () => {
	const { t } = useTranslation();
	const items = t("services.process.steps", { returnObjects: true });

	const [actualContainer, setActualContainer] = useState(1);

	const handleProcessExpansion = (e, containerNumber) => {
		e.preventDefault();
		setActualContainer(containerNumber);
	};

	return (
		<div className="process-bg">
			<h2 className="process-title">{t("services.process.title")}</h2>
			<div className="process-containers">
				{items.map((step, index) => (
					<div
						key={index}
						className={
							actualContainer === index + 1
								? "process-container"
								: "process-container-small"
						}
						style={{
							backgroundImage: `url(${require(
								"../../assets/" + step["image"],
							)})`,
						}}
						onClick={(e) => handleProcessExpansion(e, index + 1)}
					>
						<div
							className={
								actualContainer === index + 1
									? "process-container-step"
									: "process-container-step-small"
							}
						>
							<img
								alt={index}
								src={require("../../assets/" + step["icon"])}
								className={
									actualContainer === index + 1
										? "process-container-step-icon"
										: "process-container-step-icon-small"
								}
							/>
						</div>
						<div
							className={
								actualContainer === index + 1
									? "process-container-texts"
									: "process-container-texts-small"
							}
						>
							<div
								className={
									actualContainer === index + 1
										? "process-container-title"
										: "process-container-title-small"
								}
							>
								{step["title"]}
							</div>
							<div
								className={
									actualContainer === index + 1
										? "process-container-subtitle"
										: "process-container-subtitle-small"
								}
							>
								{step["subtitle"]}
							</div>
						</div>
						<div
							className={
								actualContainer === index + 1
									? "process-container-content"
									: "process-container-content-small"
							}
						>
							{step["description"]}
						</div>
					</div>
				))}
			</div>
		</div>
	);
};

export default Process;
